<template>
  <div class="container">
    <div class="dialog">
      <div class="dialog-mask">
        <div class="edit-job">
          <div class="job-box">
            <div class="box-header">
              <h2 class="title">{{ title }}</h2>
              <div class="header-modal-close">
                <i class="el-icon-close" @click.prevent="close"></i>
              </div>
            </div>
            <div class="section-main">
              <div class="tab-bar">
                <!-- 第一个标签，点击切换激活状态 -->
                <div class="tab-item" :class="{ active: currentTab === 'basic' }" @click="currentTab = 'basic'"
                  style="margin-right: 5px;">
                  招呼设置
                </div>
                <!-- 第二个标签 -->
                <div class="tab-item" :class="{ active: currentTab === 'filter' }" @click="currentTab = 'filter'">
                  回复设置
                </div>
                <div class="tab-item" :class="{ active: currentTab === 'again' }" @click="currentTab = 'again'">
                  复聊设置
                </div>
              </div>
              <div class="tab-box" v-if="currentTab === 'basic'">
                <div class="section" v-if="this.name !== 'Edit'">
                  <h3 class="section-title">拷贝招呼数据</h3>
                  <el-select v-model="hisData" placeholder="请选择需要拷贝的职位" size="small" @change="gethistoryData"
                    @visible-change="showhisData">
                    <el-option v-for="item in hisJobs" :key="item.LPid" :label="item.positionName" :value="item.LPid">
                    </el-option>
                  </el-select>
                </div>
                <div class="section">
                  <h3 class="section-title">筛选条件</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">年龄范围</div>
                        <div class="value ages">
                          <input maxlength="2" type="text" v-model="post.minAge" placeholder="min" />
                          <span>—</span>
                          <input maxlength="2" type="text" v-model="post.maxAge" placeholder="max" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">性别要求</div>
                        <div class="value">
                          <el-radio-group v-model="post.gender">
                            <el-radio :label="2">不限</el-radio>
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="0">女</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">目前城市</div>
                        <div class="value">
                          <input type="text" v-model="post.mqCity" placeholder="请输入目前城市，多个用空格分割" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">期望城市</div>
                        <div class="value">
                          <input type="text" v-model="post.qwCity" placeholder="请输入期望城市，多个用空格分割" />
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">跳槽频繁</div>
                        <div class="value">
                          <el-radio-group v-model="post.jobHopping">
                            <el-radio :label="0">不限</el-radio>
                            <el-radio :label="1">近5年不超过3段</el-radio>
                            <el-radio :label="2">近3年不超过2段</el-radio>
                            <el-radio :label="3">近2段均不低于2年</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">学历要求</div>
                        <div class="value">
                          <el-radio-group v-model="post.eduRequire">
                            <el-radio :label="0">不限</el-radio>
                            <el-radio :label="1">大专</el-radio>
                            <el-radio :label="2">本科</el-radio>
                            <el-radio :label="3">硕士</el-radio>
                            <el-radio :label="4">博士</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">行业类别</div>
                        <div class="value">
                          <input type="text" v-model="post.industry" placeholder="请输入行业，多个用空格分割" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">院校要求</div>
                        <div class="value edu">
                          <el-checkbox-group v-model="collegeRequires" @change="collegeChange">
                            <el-checkbox label="不限" @click.native="handleUnlimitedClick"></el-checkbox>
                            <el-checkbox label="统招本科"></el-checkbox>
                            <el-checkbox label="985"></el-checkbox>
                            <el-checkbox label="211"></el-checkbox>
                            <el-checkbox label="双一流院校"></el-checkbox>
                            <el-checkbox label="海外名校"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">求职状态</div>
                        <div class="value active">
                          <el-radio-group v-model="post.jobIntention">
                            <el-radio :label="0">不限</el-radio>
                            <el-radio :label="1">离职正在找工作</el-radio>
                            <el-radio :label="2">在职寻新工作</el-radio>
                            <el-radio :label="3">在职看新机会</el-radio>
                            <el-radio :label="4">在职无跳槽打算</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">活跃条件</div>
                        <div class="value active">
                          <el-radio-group v-model="post.activeCondi">
                            <el-radio :label="0">不限</el-radio>
                            <el-radio :label="1">今日活跃</el-radio>
                            <el-radio :label="2">3天内活跃</el-radio>
                            <el-radio :label="3">7天内活跃</el-radio>
                            <el-radio :label="4">30天内活跃</el-radio>
                            <el-radio :label="5">最近三个月活跃</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">基础信息</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">发布职位名称
                          <el-tooltip class="item" effect="dark" content="名称须跟发布职位名称一致" placement="top">
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <div class="value">
                          <input type="text" v-model="post.positionName" placeholder="请输入发布职位名称" :disabled="isEdit" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">招呼数量</div>
                        <div class="value">
                          <input maxlength="3" type="text" v-model="post.recruitNum" placeholder="请输入打招呼数量" />
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">胜任分数</div>
                        <div class="value">
                          <input maxlength="2" v-model="post.recruitScore" type="text" placeholder="请输入匹配分数，满分100" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">淘汰分数</div>
                        <div class="value">
                          <input maxlength="2" type="text" v-model="post.mismatchScore" placeholder="请输入低于多少分，点击不合适" />
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">工作岗位名称</div>
                        <div class="value">
                          <input type="text" v-model="post.jobName" placeholder="请输入工作岗位名称" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">薪资范围（以K为单位）</div>
                        <div class="value ages">
                          <input maxlength="2" type="text" v-model="post.minSalary" placeholder="min" />
                          <span>—</span>
                          <input maxlength="3" type="text" v-model="post.maxSalary" placeholder="max" />
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">仅沟通在线人选</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.onLineGreet">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">过滤同事已聊</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.Chatted">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">简历关键词检索
                    <el-switch style="margin-left:10px" v-model="post.keyType" active-text="全部词" inactive-text="任意词">
                    </el-switch>
                    <el-switch style="margin-left:20px" v-model="post.resumeType" active-text="匹配最近三段"
                      inactive-text="匹配所有信息">
                    </el-switch>
                  </h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="keyInput" class="tag-input" placeholder="输入关键词后按回车添加" @keyup.enter="addKey" />
                      <button class="add-btn" @click="addKey">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in keywords" closable :disable-transitions="false"
                        @close="removeKey(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">
                    <span>学校专业检索</span>
                  </h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="MajorInput" class="tag-input" placeholder="输入专业名称后按回车添加"
                        @keyup.enter="addMajor" />
                      <button class="add-btn" @click="addMajor">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in majorwords" closable :disable-transitions="false"
                        @close="removeMajor(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">目标公司检索</h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="mbInput" class="tag-input" placeholder="输入目标公司后按回车添加" @keyup.enter="addMb" />
                      <button class="add-btn" @click="addMb">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in contains" closable :disable-transitions="false"
                        @close="removeMb(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">过滤公司检索</h3>
                  <div class="tag-input-area">
                    <div class="tag-box">
                      <input v-model="glInput" class="tag-input" placeholder="输入过滤公司后按回车添加" @keyup.enter="addGl" />
                      <button class="add-btn" @click="addGl">添加</button>
                    </div>
                    <div class="tag-item">
                      <el-tag size="small" :key="i" v-for="(tag, i) in filters" closable :disable-transitions="false"
                        @close="removeGl(i)">
                        {{ tag }}
                      </el-tag>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">打招呼内容</h3>
                  <div class="greet-desc">
                    <textarea v-model="post.greetDesc" maxlength="255"></textarea>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">岗位胜任要求</h3>
                  <div class="job-desc">
                    <textarea v-model="post.jobDesc"></textarea>
                  </div>
                </div>
              </div>
              <div class="tab-box" v-else-if="currentTab === 'filter'">
                <div class="section">
                  <el-link type="danger" :underline="false">剩余积分：{{ points }}</el-link>
                </div>
                <div class="section">
                  <h3 class="section-title">基础功能设置</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">AI自动回复</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AIChat">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">AI请求简历</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AIreqRes">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">AI交换电话</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AIchangeNum">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">AI交换微信</div>
                        <div class="value chat">
                          <label class="switch">
                            <input type="checkbox" v-model="post.AichangeWx">
                            <span class="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">聊天起止时间</div>
                        <div class="value chatTime">
                          <el-time-select size="small" placeholder="起始时间" v-model="post.AIChatstartTime"
                            :picker-options="{
                              start: '08:00',
                              step: '00:30',
                              end: '18:30'
                            }">
                          </el-time-select>
                          <span>—</span>
                          <el-time-select size="small" placeholder="结束时间" v-model="post.AIChatendTime" :picker-options="{
                            start: '08:00',
                            step: '00:30',
                            end: '23:30',
                            minTime: post.AIChatstartTime
                          }">
                          </el-time-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title">知识库配置</div>
                  <div style="margin-bottom: 10px;" v-if="this.name !== 'Edit'">
                    <el-select v-model="hishfData" placeholder="请选择需要拷贝的职位" size="small" @change="gethfhistoryData"
                      @visible-change="showhisData">
                      <el-option v-for="item in hisJobs" :key="item.LPid" :label="item.positionName" :value="item.LPid">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box btm">
                        <div class="name">关键词内容 (多个内容用，分隔)</div>
                        <div class="value">
                          <input type="text" v-model="zskey" placeholder="请输入关键词内容" />
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">回复内容</div>
                        <div class="key-desc">
                          <textarea v-model="zsvalue"></textarea>
                        </div>
                      </div>
                      <div class="btn">
                        <button class="add-btn" v-if="title === '编辑职位'" @click="addKnow()">{{ zsbtn }}</button>
                      </div>
                    </div>
                    <div class="position-list">
                      <div class="position-item" v-for="(item, index) in keyList" :key="index">
                        <div class="item-box" style="overflow: hidden;">
                          <div class="position-info">
                            <span class="position-name">关键词：{{ item.key }}</span>
                            <div class="meta-info">
                              <span>内容: {{ item.value }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="action-btns" v-if="title === '编辑职位'">
                          <button class="edit-btn" @click="keyEdit(item.id, index)">编辑</button>
                          <button class="delete-btn" @click="keyDelete(item.id)">删除</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title">AI回复知识库
                    <el-switch v-model="post.AIzskhf"></el-switch>
                  </div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box" style="margin-bottom:5px;">
                        <div class="key-desc">
                          <textarea style="height:120px" v-model="post.AIzsknr" placeholder="填写岗位基本信息，如工作时间、招聘要求、薪资待遇、工作地址等，AI助手会参照这些信息来解答求职者的问题。例：
                          工作时间：XXXXX；
                          岗位要求：XXXXX；
                          薪资待遇：XXXXX；"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <div class="section-title">交换回复设置</div>
                  <div class="section-box">
                    <div class="key-box-item">
                      <div class="item-box" style="margin-bottom:5px;">
                        <div class="name">交换简历后回复</div>
                        <div class="key-desc">
                          <textarea v-model="post.AiJlhf"></textarea>
                        </div>
                      </div>
                      <div class="item-box">
                        <div class="name">交换微信后回复</div>
                        <div class="key-desc">
                          <textarea v-model="post.AiWxhf"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section" v-if="false">
                  <h3 class="section-title">AI追问设置</h3>
                  <div class="section-box">
                    <div class="section-box-item key-box-item">
                      <div class="item-box xh tw">
                        <div class="name">追问序号</div>
                        <div class="value">
                          <input type="text" v-model="post.jobName" placeholder="请输入序号" />
                        </div>
                      </div>
                      <div class="item-box nr tw">
                        <div class="name">追问内容</div>
                        <div class="value">
                          <input type="text" v-model="post.jobName" placeholder="请输入提问内容" />
                        </div>
                      </div>
                    </div>
                    <div class="btn">
                      <button class="add-btn" v-if="title === '编辑职位'">添加</button>
                    </div>
                    <div class="position-list" v-if="title === '编辑职位'">
                      <div class="position-item" v-for="(item, index) in zwList" :key="index"
                        :class="clickIndex === index ? 'active' : ''" @click="activeHover(index, item.id)">
                        <div class="item-box">
                          <div class="position-info">
                            <span class="position-name">关键词：{{ item.positionName }}</span>
                            <div class="meta-info">
                              <span>内容: {{ item.recruitNum }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="action-btns">
                          <button class="edit-btn" @click="keyEdit(item.id)">编辑</button>
                          <button class="delete-btn" @click="keyDelete(item.id, index)">删除</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-box" v-else>
                <div class="section">
                  <h3 class="section-title">基础功能设置</h3>
                  <div class="section-box">
                    <div class="section-box-item">
                      <div class="item-box">
                        <div class="name">复聊起止时间</div>
                        <div class="value chatTime">
                          <el-time-select size="small" placeholder="起始时间" v-model="post.againstartTime" :picker-options="{
                            start: '08:00',
                            step: '00:30',
                            end: '18:30'
                          }">
                          </el-time-select>
                          <span>—</span>
                          <el-time-select size="small" placeholder="结束时间" v-model="post.againendTime" :picker-options="{
                            start: '08:00',
                            step: '00:30',
                            end: '23:30',
                            minTime: post.againstartTime
                          }">
                          </el-time-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section">
                  <h3 class="section-title">复聊内容设置</h3>
                  <div style="margin-bottom: 10px;" v-if="this.name !== 'Edit'">
                    <el-select v-model="hisflData" placeholder="请选择需要拷贝的职位" size="small" @change="getflhistoryData"
                      @visible-change="showhisData">
                      <el-option v-for="item in hisJobs" :key="item.LPid" :label="item.positionName" :value="item.LPid">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="section-box">
                    <div class="section-box-item key-box-item">
                      <div class="item-box xh tw">
                        <div class="name">复聊次数</div>
                        <div class="value">
                          <input type="text" v-model="flNum" placeholder="例如 第1次" />
                        </div>
                      </div>
                      <div class="item-box nr tw">
                        <div class="name">复聊内容</div>
                        <div class="value">
                          <input type="text" v-model="flValue" placeholder="请输入复聊内容" />
                        </div>
                      </div>
                    </div>
                    <div class="btn">
                      <button class="add-btn" v-if="title === '编辑职位'" @click="addAgain()">{{ flbtn }}</button>
                    </div>
                    <div class="position-list">
                      <div class="position-item" v-for="(item, index) in flList" :key="index">
                        <div class="item-box">
                          <div class="position-info">
                            <span class="position-name">第{{ item.flNum }}次复聊</span>
                            <div class="meta-info">
                              <span>内容: {{ item.flValue }} </span>
                            </div>
                          </div>
                        </div>
                        <div class="action-btns" v-if="title === '编辑职位'">
                          <button class="edit-btn" @click="againEdit(item.id, index)">编辑</button>
                          <button class="delete-btn" @click="againDelete(item.id)">删除</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer">
              <button class="save-btn" @click="save">保存</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLPJobList, createLPJob, updateLPJob, getLPJobInfo, addKnow, updateKnow, delKnow, getKnow, addAgain, updateAgain, delAgain, getAgain } from '@/request/api'
export default {
  props: {
    name: String,
    jobID: {
      type: Number,
      default: 0
    }
  },
  created() {
    if (!sessionStorage.getItem("LoginInfo")) {
      this.$message.error('请先登录！');
      return;
    }
    this.points = JSON.parse(sessionStorage.getItem("LoginInfo")).points === null ? 0 : JSON.parse(sessionStorage.getItem("LoginInfo")).points;
    if (this.name === 'Edit') {
      this.title = '编辑职位'
      this.post.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
      this.EditPost.jobID = this.jobID;
      this.isEdit = true;
      this.getJobInfo();
      this.getKeyList();
      this.getAgainList();
    } else {
      this.title = '新增职位'
      this.isEdit = false;
      this.post.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
    }
  },
  data() {
    return {
      title: '编辑职位',
      currentTab: 'basic',
      isEdit: false,
      Arr: {}, // 新结果
      keyInput: '',
      MajorInput: '',
      mbInput: '',
      glInput: '',
      points: '',// 积分
      zskey: '', // 知识库关键词
      zsvalue: '', // 知识库内容
      zsbtn: '添加',
      zsID: null,
      flNum: '第1次', // 复聊次数
      flValue: '', // 复聊内容
      flbtn: '添加',
      flID: null,
      choose: true,// 
      keywords: [],// 关键词
      majorwords: [],// 专业要求
      contains: [],// 目标公司
      filters: [],// 过滤公司
      clickIndex: null,
      collegeRequires: ['不限'], // 院校要求
      keyList: [],
      zwList: [],
      flList: [],
      hisflData: '',
      hishfData: '',
      hisData: '',
      hisJobs: [],
      post: {
        username: '',
        minAge: '', // 最小年龄
        maxAge: '', // 最大年龄
        gender: 2, // 性别
        mqCity: '', // 目前城市
        qwCity: '', // 期望城市
        industry: '', // 行业
        jobHopping: 0, // 跳槽频繁
        eduRequire: 0, // 学历要求
        activeCondi: 0, // 活跃条件
        collegeRequire: '', // 院校要求
        jobIntention: 0, // 求职意向
        positionName: '', // 职位名称
        recruitNum: '', // 招呼数量
        recruitScore: 88, // 胜任分数
        mismatchScore: 0, // 淘汰分数
        jobName: '', // 岗位名称
        greetDesc: '', // 招呼内容
        keyType: false,// 关键词类型
        resumeType: false,// 匹配类型
        jobDesc: '', // 职位描述
        minSalary: '', // 最低薪资
        maxSalary: '', // 最高薪资
        keyword: '', // 关键词
        majorword: '', // 专业词
        contain: '', // 包含公司
        filter: '', // 过滤公司
        Chatted: false, // 过滤同事已聊
        onLineGreet: false, // 仅对在线人选打招呼
        AIChat: false, // AI聊天开关
        AIzskhf: false, // AI知识库回复
        AIzsknr: '', // AI知识库内容
        AIreqRes: true, // AI请求简历
        AIchangeNum: false, // AI交换电话
        AichangeWx: false, // AI请求微信
        AIChatstartTime: '', //AI开始时间
        AIChatendTime: '', //AI结束时间
        againstartTime: '', //复聊开始时间
        againendTime: '', //复聊结束时间
        AiJlhf: '', // 简历回复消息
        AiWxhf: '', // 微信回复消息
        channel: 1
      },
      EditPost: {
        jobID: 0,
      }
    };
  },
  methods: {
    getflhistoryData() {
      this.EditPost.jobID = this.hisflData;
      this.getAgainList();
    },
    gethfhistoryData() {
      this.EditPost.jobID = this.hishfData;
      this.getKeyList();
    },
    gethistoryData() {
      this.EditPost.jobID = this.hisData;
      this.getJobInfo();
    },
    async showhisData(bool) {
      if (bool) {
        var { data: res } = await getLPJobList({ username: JSON.parse(sessionStorage.getItem("LoginInfo")).username });
        this.hisJobs = res.data;
      }
    },
    async getJobInfo() {
      var { data: res } = await getLPJobInfo({ username: this.post.username, jobID: this.EditPost.jobID, channel: 1 })
      if (res.code === 200) {
        this.Arr = res.data;
        this.points = res.points;
        this.keywords = this.Arr.recruitKey?.includes(',') ? this.Arr.recruitKey.split(',') : this.Arr.recruitKey ? [this.Arr.recruitKey] : [];
        this.majorwords = this.Arr.recruitMajor?.includes(',') ? this.Arr.recruitMajor.split(',') : this.Arr.recruitMajor ? [this.Arr.recruitMajor] : [];
        this.filters = this.Arr.filterCom?.includes(',') ? this.Arr.filterCom.split(',') : this.Arr.filterCom ? [this.Arr.filterCom] : [];
        this.contains = this.Arr.containsCom?.includes(',') ? this.Arr.containsCom.split(',') : this.Arr.containsCom ? [this.Arr.containsCom] : [];
        this.collegeRequires = this.Arr.collegeRequire?.includes(',') ? this.Arr.collegeRequire.split(',') : [this.Arr.collegeRequire];
        this.post.minAge = this.Arr.minAge == 0 ? '' : this.Arr.minAge;
        this.post.maxAge = this.Arr.maxAge == 0 ? '' : this.Arr.maxAge;
        this.post.gender = this.Arr.gender;
        this.post.mqCity = this.Arr.mqCity;
        this.post.qwCity = this.Arr.qwCity;
        this.post.industry = this.Arr.industry;
        this.post.jobHopping = this.Arr.jobHopping;
        this.post.eduRequire = this.Arr.eduRequire;
        this.post.activeCondi = this.Arr.activeCondi;
        this.post.jobIntention = this.Arr.jobIntention;
        this.post.positionName = this.Arr.positionName;
        this.post.recruitNum = this.Arr.recruitNum == 0 ? '' : this.Arr.recruitNum;
        this.post.recruitScore = this.Arr.recruitScore;
        this.post.mismatchScore = this.Arr.mismatchScore;
        this.post.jobName = this.Arr.jobName;
        this.post.greetDesc = this.Arr.greetDesc;
        this.post.jobDesc = this.Arr.recruitDesc;
        this.post.AiJlhf = this.Arr.aijlhf;
        this.post.AiWxhf = this.Arr.aiwxhf;
        this.post.minSalary = this.Arr.minSalary == 0 ? '' : this.Arr.minSalary;;
        this.post.maxSalary = this.Arr.maxSalary == 0 ? '' : this.Arr.maxSalary;;
        this.post.Chatted = this.Arr.chatted === 1 ? true : false;
        this.post.onLineGreet = this.Arr.onLineGreet === 1 ? true : false;
        this.post.AIChat = this.Arr.aiSwitch === 1 ? true : false;
        this.post.AIzskhf = this.Arr.aizskhf === 1 ? true : false;
        this.post.AIzsknr = this.Arr.aizsknr;
        this.post.AIreqRes = this.Arr.aireqResume === 1 ? true : false;
        this.post.AIchangeNum = this.Arr.aichangeNum === 1 ? true : false;
        this.post.AichangeWx = this.Arr.aichangeWx === 1 ? true : false;
        this.post.keyType = this.Arr.keyType === 1 ? true : false;
        this.post.resumeType = this.Arr.resumeType === 1 ? true : false;
        this.post.AIChatstartTime = this.Arr.aistartTime;
        this.post.AIChatendTime = this.Arr.aiendTime;
        this.post.againstartTime = this.Arr.flstartTime;
        this.post.againendTime = this.Arr.flendTime;
      } else {
        this.$message.error('当前用户Token已过期，请重新登录！');
        this.$router.push('/login');
        return;
      }
    },
    close() {
      this.$emit('MessageClose')
    },
    collegeChange(val) {
      if (this.collegeRequires.length < 1) {
        this.collegeRequires = ['不限']
      } else {
        this.collegeRequires = val.filter(item => item !== '不限');
      }
    },
    handleUnlimitedClick(event) {
      if (!this.collegeRequires.includes('不限')) {
        this.collegeRequires = ['不限'];
        event.stopPropagation();
      }
    },
    addKey() {
      if (this.keyInput.trim()) {
        this.keywords.push(this.keyInput.trim());
        this.keyInput = '';
      }
    },
    addMajor() {
      if (this.MajorInput.trim()) {
        this.majorwords.push(this.MajorInput.trim());
        this.MajorInput = '';
      }
    },
    addMb() {
      if (this.mbInput.trim()) {
        this.contains.push(this.mbInput.trim());
        this.mbInput = '';
      }
    },
    addGl() {
      if (this.glInput.trim()) {
        this.filters.push(this.glInput.trim());
        this.glInput = '';
      }
    },
    removeKey(index) {
      this.keywords.splice(index, 1);
    },
    removeMajor(index) {
      this.majorwords.splice(index, 1);
    },
    removeMb(index) {
      this.contains.splice(index, 1);
    },
    removeGl(index) {
      this.filters.splice(index, 1);
    },
    async save() {
      if (this.post.positionName == '' || this.post.positionName == null) {
        this.$message.warning('发布职位名称不能为空');
        return;
      }
      if (this.keywords.length > 0) {
        this.post.keyword = this.keywords.join(',');
      }
      if (this.majorwords.length > 0) {
        this.post.majorword = this.majorwords.join(',');
      }
      if (this.contains.length > 0) {
        this.post.contain = this.contains.join(',');
      }
      if (this.filters.length > 0) {
        this.post.filter = this.filters.join(',');
      }
      if (this.collegeRequires.length > 0) {
        this.post.collegeRequire = this.collegeRequires.join(',');
      }
      if (this.name == 'Add') {
        const { data: res } = await createLPJob(this.post);
        if (res.code === 200) {
          if (this.flList.length > 0) {
            this.flList.forEach(async item => {
              await addAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: res.data, flNum: item.flNum, flValue: item.flValue, channel: 1 });
            })
          }
          if (this.keyList.length > 0) {
            this.keyList.forEach(async item => {
              await addKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: res.data, zskey: item.key, zsvalue: item.value, channel: 1 });
            })
          }
          this.$message.success('添加成功！');
        } else {
          this.$message.error(res.message);
        }
        this.$emit('AddClose')
      } else {
        const { data: res } = await updateLPJob({ ...this.post, ...this.EditPost });
        this.$emit('EditClose')
      }
    },
    async addKnow() {
      if (this.zsbtn === '添加') {
        var { data: res } = await addKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, zskey: this.zskey, zsvalue: this.zsvalue, channel: 3 });
        if (res.code === 200) {
          this.$message.success('添加成功！');
        } else {
          this.$message.error(res.message);
        }
      } else {
        var { data: res } = await updateKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, knowID: this.zsID, jobID: this.EditPost.jobID, zskey: this.zskey, zsvalue: this.zsvalue, channel: 3 });
        if (res.code === 200) {
          this.$message.success('修改成功！');
          this.zsbtn = '添加';
        } else {
          this.$message.error(res.message);
        }
      }
      this.getKeyList();
      this.zskey = '';
      this.zsvalue = '';
    },
    keyEdit(id, index) {
      this.zsbtn = '修改';
      this.zsID = id;
      this.zskey = this.keyList[index].key;
      this.zsvalue = this.keyList[index].value;
    },
    async keyDelete(id) {
      var { data: res } = await delKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, knowID: id, channel: 3 });
      this.keyList = res.data;
    },
    async getKeyList() {
      var { data: res } = await getKnow({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, channel: 3 });
      this.keyList = res.data;
    },
    async addAgain() {
      if (this.flNum.indexOf('第') === -1 || this.flNum.indexOf('次') === -1) {
        this.$message.warning('复聊次数格式有误，正确格式：第1次');
        return;
      }
      if (this.flbtn === '添加') {
        var { data: res } = await addAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, flNum: this.flNum, flValue: this.flValue, channel: 3 });
      } else {
        var { data: res } = await updateAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, againID: this.flID, jobID: this.EditPost.jobID, flNum: this.flNum, flValue: this.flValue, channel: 3 });
        this.flbtn = '添加';
      }
      this.getAgainList();
      this.flNum = '';
      this.flValue = '';
    },
    againEdit(id, index) {
      this.flbtn = '修改';
      this.flID = id;
      this.flNum = "第" + this.flList[index].flNum + "次";
      this.flValue = this.flList[index].flValue;
    },
    async againDelete(id) {
      var { data: res } = await delAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, againID: id, channel: 3 });
      this.flList = res.data;
    },
    async getAgainList() {
      var { data: res } = await getAgain({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: this.EditPost.jobID, channel: 3 });
      this.flList = res.data;
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  overflow: hidden;


  .dialog-mask {
    position: relative;
    top: 50%;
    left: 50%;
    width: 80%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
  }

  .mark {
    background: #f3f3f3;
    color: #000;
  }
}

.edit-job {
  background-color: #111927;
  padding: 0 20px;
  color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .box-header {
    position: relative;

    .title {
      user-select: none;
      padding: 20px 0 10px 20px;
      font-weight: bold;
      background: linear-gradient(90deg, #45A2FF, #FF6B6B);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      font-size: 24px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      padding-bottom: 5px;
      margin-bottom: 6px;
    }

    .header-modal-close {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1px;
      width: 40px;
      height: 40px;
      font-size: 24px;
      font-weight: bold;
      align-items: center;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      justify-content: center;
    }

    .header-modal-close:hover {
      background-color: rgba(0, 119, 255, 0.06);
      border-radius: 20px;
    }
  }

  .section-main {
    height: 400px;
    overflow-y: auto;
    /* 美化滚动条（适用于Chrome、Safari、Edge等WebKit/Blink内核浏览器） */
    scrollbar-width: thin;
    /* Firefox支持的细滚动条 */
    scrollbar-color: rgba(156, 163, 175, 0.5) transparent;
    /* Firefox滚动条颜色 */
    padding: 0 20px;

    .tab-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: fit-content;
      margin: 20px 0;
      background-color: #303a4a;
      border-radius: 10px;
      box-shadow: 0px 0px 1px 1px #252d3a;
      padding: 3px;
    }

    .tab-item {
      /* 标签基础样式，可自定义 padding、字体等 */
      padding: 10px 12px;
      border-radius: 8px;
      cursor: pointer;
      /* 未激活时的背景，这里简单设为浅灰色示例 */
      transition: all 0.3s ease;
      white-space: nowrap;
      font-size: 14px;
      color: #a1a1aa;
    }

    /* 激活态样式，用渐变实现类似效果 */
    .tab-item.active {
      background: linear-gradient(90deg, #56ccf2, #2f80ed);
      color: #fff;
    }

    .tab-item:hover {
      color: #fff;
    }

    .section {
      border-radius: 5px;
      padding: 10px 20px;
      margin-bottom: 16px;
      box-shadow: 0px 0px 1px 1px #252d3a;

      .section-title {
        font-size: 16px;
        margin-bottom: 10px;
        user-select: none;
      }

      .section-box {

        .section-box-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          .item-box {
            width: 45%;
            background-color: #303a4a;
            padding: 10px;
            border-radius: 10px;
          }

          .name {
            user-select: none;
            font-size: 14px;
            margin-bottom: 5px;
          }



          .value {
            font-size: 14px;
            padding-top: 5px;

            input {
              background-color: #303a4a;
              border: none;
              /* 移除所有边框 */
              outline: none;
              color: #fff;
              width: 100%;
              /* 移除聚焦时的轮廓线 */
            }

            ::v-deep .el-radio__inner {
              border-radius: 3px;
            }

            input:focus {
              box-shadow: none;
              /* 可选：移除某些浏览器可能添加的阴影 */
            }
          }

          .chat {
            .switch {
              --secondary-container: #495867;
              --primary: #45A2FF;
              font-size: 17px;
              position: relative;
              display: inline-block;
              width: 55px;
              height: 20px;
            }

            .switch input {
              display: none;
              opacity: 0;
              width: 0;
              height: 0;
            }

            .slider {
              position: absolute;
              cursor: pointer;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #313033;
              transition: .2s;
              border-radius: 30px;
            }

            .slider:before {
              position: absolute;
              content: "";
              height: 15px;
              width: 15px;
              border-radius: 20px;
              left: 0.2em;
              bottom: 0.2em;
              background-color: #aeaaae;
              transition: .4s;
            }

            input:checked+.slider::before {
              background-color: var(--primary);
            }

            input:checked+.slider {
              background-color: var(--secondary-container);
            }

            input:focus+.slider {
              box-shadow: 0 0 1px var(--secondary-container);
            }

            input:checked+.slider:before {
              transform: translateX(1.9em);
            }
          }

          .ages {
            display: flex;
            align-items: center;

            span {
              margin: 0 10px;
            }

            input {
              width: 18%;
              text-align: center;
            }

            .el-date-editor--time-select {
              ::v-deep .el-input__inner {
                border-radius: 20px;
              }
            }
          }

          .chatTime {
            display: flex;
            align-items: center;

            span {
              margin: 0 18px;
            }

            input {
              width: 18%;
              text-align: center;
            }

            .el-date-editor--time-select {
              ::v-deep .el-input__inner {
                border-radius: 20px;
              }
            }
          }

          .active {
            .el-radio-group {
              display: flex;
              flex-wrap: wrap;

              .el-radio {
                width: 28%;
                margin-bottom: 3px;
              }
            }
          }

          .edu {
            .el-checkbox-group {
              display: flex;
              flex-wrap: wrap;

              .el-checkbox {
                width: 22%;
                margin-bottom: 3px;
              }
            }
          }
        }

        .key-box-item {
          margin-bottom: 10px;

          .btm {
            margin-bottom: 5px;
          }

          .item-box {
            background-color: #303a4a;
            padding: 10px;
            border-radius: 10px;

            .key-desc {

              textarea {
                white-space: pre-line;
                width: 100%;
                height: 50px;
                background-color: #303a4a;
                padding: 2px;
                border: none;
                /* 移除所有边框 */
                outline: none;
                color: #fff;
                resize: none;
                /* 完全禁用调整功能，移除右下角图标 */
                border-radius: 5px;
                /* 移除聚焦时的轮廓线 */
                font-family: 'Arial', sans-serif;
              }

              textarea:focus {
                box-shadow: none;
                /* 可选：移除某些浏览器可能添加的阴影 */
              }
            }
          }

          .btn {
            margin: 5px 0;
            text-align: right;

            .add-btn {
              padding: 4px 15px;
              background-color: #675bf5;
              border: none;
              border-radius: 4px;
              color: #fff;
              cursor: pointer;
              margin-left: 10px;
            }
          }

          .name {
            user-select: none;
            font-size: 14px;
            margin-bottom: 5px;
          }

          .value {
            font-size: 14px;
            padding-top: 5px;

            input {
              background-color: #303a4a;
              border: none;
              /* 移除所有边框 */
              outline: none;
              color: #fff;
              width: 100%;
              /* 移除聚焦时的轮廓线 */
            }

            ::v-deep .el-radio__inner {
              border-radius: 3px;
            }

            input:focus {
              box-shadow: none;
              /* 可选：移除某些浏览器可能添加的阴影 */
            }
          }

          .xh {
            width: 20%;
          }

          .nr {
            width: 100%;
          }

          .sy {
            width: 20%;
          }

          .tw {
            margin-right: 3px;
          }
        }

        .btn {
          margin: 5px 0;
          text-align: right;

          .add-btn {
            padding: 4px 15px;
            background-color: #675bf5;
            border: none;
            border-radius: 4px;
            color: #fff;
            cursor: pointer;
            margin-left: 10px;
          }
        }

        .position-list {
          display: flex;
          height: 188px;
          flex-direction: column;
          gap: 10px;
          overflow-y: auto;
          background-color: #161e2e;
          padding: 10px;
          border-radius: 6px;
          /* 美化滚动条（适用于Chrome、Safari、Edge等WebKit/Blink内核浏览器） */
          scrollbar-width: thin;
          /* Firefox支持的细滚动条 */
          scrollbar-color: rgba(156, 163, 175, 0.5) transparent;
          /* Firefox滚动条颜色 */
          box-shadow: 0px 0px 1px 1px #252d3a;

          .position-item {
            background-color: #303a4a;
            padding: 10px;
            border-radius: 8px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item-box {
              display: flex;
              align-items: center;
              width: 78%;
            }

            .position-info {
              display: flex;
              flex-direction: column;
              gap: 5px;

              .position-name {
                font-weight: bold;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .meta-info {
                display: flex;
                align-items: center;
                gap: 10px;
                color: #aaa;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

            }

            .action-btns {
              display: flex;
              gap: 10px;

              .edit-btn {
                background-color: #6C63FF;
                color: #fff;
                border: none;
                padding: 4px 10px;
                border-radius: 4px;
                cursor: pointer;
              }

              .edit-btn:hover {
                background-color: #8079fe;
              }

              .delete-btn {
                background-color: #FF4757;
                color: #fff;
                border: none;
                padding: 4px 10px;
                border-radius: 4px;
                cursor: pointer;
              }

              .delete-btn:hover {
                background-color: #fa6d79;
              }
            }
          }

          .active {
            background-color: rgb(84, 80, 103);

            .position-name {
              color: #45A2FF;
            }
          }

          .position-item:hover {
            background-color: rgb(84, 80, 103);

            .position-name {
              color: #45A2FF;
            }
          }
        }

        .position-list::-webkit-scrollbar {
          width: 8px;
          /* 滚动条宽度 */
        }

        .position-list::-webkit-scrollbar-track {
          background: transparent;
          /* 滚动条轨道背景透明 */
        }

        .position-list::-webkit-scrollbar-thumb {
          background-color: rgba(156, 163, 175, 0.5);
          /* 滚动条滑块颜色（灰色半透明） */
          border-radius: 3px;
          /* 滑块圆角 */
        }

        .position-list::-webkit-scrollbar-thumb:hover {
          background-color: rgba(107, 114, 128, 0.7);
          /* 悬停时滑块颜色加深 */
        }
      }

      .section-title::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 15px;
        margin-right: 5px;
        background-color: #675bf5;
        vertical-align: middle;
        border-radius: 2px;
        margin-bottom: 2px;
      }

      .tag-input-area {
        .tag-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;

          .tag-input {
            flex: 0.88;
            width: 80%;
            padding: 8px;
            border: 1px solid #444;
            border-radius: 4px;
            background-color: #2c2e36;
            color: #fff;
          }

          .add-btn {
            flex: 0.08;
            padding: 8px 15px;
            background-color: #675bf5;
            border: none;
            border-radius: 4px;
            color: #fff;
            cursor: pointer;
          }

          .add-btn:hover {
            background-color: #4c44d7;
          }

        }

        .tag-item {
          display: inline-block;

          .el-tag {
            margin-right: 6px;
            margin-bottom: 8px;
          }
        }
      }

      .greet-desc {
        textarea {
          white-space: pre-line;
          width: 100%;
          height: 66px;
          background-color: #303a4a;
          padding: 5px;
          border: none;
          /* 移除所有边框 */
          outline: none;
          color: #fff;
          resize: none;
          /* 完全禁用调整功能，移除右下角图标 */
          border-radius: 5px;
          /* 移除聚焦时的轮廓线 */
          font-family: 'Arial', sans-serif;
        }

        textarea:focus {
          box-shadow: none;
          /* 可选：移除某些浏览器可能添加的阴影 */
        }
      }

      .job-desc {
        textarea {
          white-space: pre-line;
          width: 100%;
          height: 200px;
          background-color: #303a4a;
          padding: 5px;
          border: none;
          /* 移除所有边框 */
          outline: none;
          color: #fff;
          resize: none;
          /* 完全禁用调整功能，移除右下角图标 */
          border-radius: 5px;
          /* 移除聚焦时的轮廓线 */
          font-family: 'Arial', sans-serif;
        }

        textarea:focus {
          box-shadow: none;
          /* 可选：移除某些浏览器可能添加的阴影 */
        }
      }
    }
  }

  .section-main::-webkit-scrollbar {
    width: 8px;
    /* 滚动条宽度 */
  }

  .section-main::-webkit-scrollbar-track {
    background: transparent;
    /* 滚动条轨道背景透明 */
  }

  .section-main::-webkit-scrollbar-thumb {
    background-color: rgba(156, 163, 175, 0.5);
    /* 滚动条滑块颜色（灰色半透明） */
    border-radius: 3px;
    /* 滑块圆角 */
  }

  .section-main::-webkit-scrollbar-thumb:hover {
    background-color: rgba(107, 114, 128, 0.7);
    /* 悬停时滑块颜色加深 */
  }


  ::v-deep textarea::-webkit-scrollbar {
    width: 8px;
    /* 滚动条宽度 */
  }

  ::v-deep textarea::-webkit-scrollbar-track {
    background: transparent;
    /* 滚动条轨道背景透明 */
  }

  ::v-deep textarea::-webkit-scrollbar-thumb {
    background-color: rgba(156, 163, 175, 0.5);
    /* 滚动条滑块颜色（灰色半透明） */
    border-radius: 3px;
    /* 滑块圆角 */
  }

  ::v-deep textarea::-webkit-scrollbar-thumb:hover {
    background-color: rgba(107, 114, 128, 0.7);
    /* 悬停时滑块颜色加深 */
  }

  .footer {
    padding: 10px 20px;
    text-align: right;

    .save-btn {
      padding: 6px 20px;
      background-color: #675bf5;
      border: none;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
    }

    .save-btn:hover {
      background-color: #4c44d7;
    }
  }
}
</style>